<template>
  <div class="columns wrapper is-mobile">
    <div class="column main-content-wrapper" :class="{ 'is-10': showMobileNav }">
      <div class="header level is-mobile">
        <div class="level-left">
          <router-link :to="{ 'name': 'dashboard' }">
            <img class="logo" src="@/assets/truckl-logo-white.png" title="Truckl - The Road to Trust" />
          </router-link>

          <font-awesome-icon icon="bars" size="lg" class="is-hidden-tablet" @click="toggleNav" />
        </div>

        <main-navigation class="nav" />

        <ul class="level-right">
          <!--
          <li class="level-item">
            <font-awesome-icon icon="search" size="lg" />
          </li>
          <li class="level-item">
            <font-awesome-icon icon="bell" size="lg" />
          </li>
          <li class="level-item">
            <font-awesome-icon icon="question-circle" size="lg" />
          </li>
          -->
          <li>
            <user-menu/>
          </li>
        </ul>
      </div>
      <div class="main container">
        <router-view :key="$route.fullPath" />
      </div>
    </div>

  </div>
</template>

<script>
import MainNavigation from '@/components/navigation-menus/MainNavigation'
import UserMenu from '@/components/navigation-menus/UserMenu'

export default {
  name: 'Portal',

  data() {
    return {
      showMobileNav: false
    }
  },

  components: {
    MainNavigation,
    UserMenu
  },

  methods: {
    toggleNav() {
      this.showMobileNav = !this.showMobileNav
    }
  }
}
</script>

<style scoped lang="scss">
$mobile: '768px';
.wrapper {
  margin: 0;
}

.nav {
  width: 100%;
}

.main {
  padding-top: 65px;
}

.logo {
  // width: 85%;
  height: 45px;
  margin: 0;
}

.header {
  height: 60px;
  padding: 0 16px;
  // background-color: rgb(33, 57, 101);
  // box-shadow: 15px -8px 20px 0px rgb(33, 57, 101);
  //margin: 0 25px;
  margin: 0;
  background: rgb(84, 85, 86);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 10;
  box-shadow: 0 0 20px 0 #00000030;
}

@media (max-width: $mobile) {
  .header {
    height: 30px;
    margin: 10px 0;
  }
}

.user-menu {
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  &:hover {
    cursor: pointer;
  }

  .user-icon {
    margin-right: 3px;
  }
}
</style>
